import { Dialog as DialogPrimitive } from 'radix-ui';

import {
  DialogDescription,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogTitle,
  DialogClose,
} from './dialog';

export const Dialog = {
  Root: DialogPrimitive.Root,
  Portal: DialogPrimitive.Portal,
  Overlay: DialogOverlay,
  Trigger: DialogPrimitive.Trigger,
  Content: DialogContent,
  Title: DialogTitle,
  Description: DialogDescription,
  Close: DialogClose,
  Header: DialogHeader,
  Footer: DialogFooter,
};
